export default class BaseAccordionPanel {
    panelOpen = false;

    togglePanel() {
        this.panelOpen = !this.panelOpen;

        window.dispatchEvent(new Event('resize'));
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('accordionPanel', () => new BaseAccordionPanel());
});
